import { ChevronLeft, ChevronRight, Check } from "lucide-react";
import { Button } from "./ui/button";

export default function WizardLayout({
  title,
  step,
  totalSteps,
  stepLabel,
  onBack,
  onNext,
  nextLabel,
  nextDisabled,
  nextDescribedBy, // el id del aviso que explica por qué «Siguiente» está desactivado
  isLastStep,
  loading,
  children,
  hideNav,
}) {
  const progress = ((step + 1) / totalSteps) * 100;
  return (
    <div className="min-h-screen bg-[#F7F5F0] pb-32">
      <header className="sticky top-0 z-30 bg-[#F7F5F0]/95 backdrop-blur border-b border-[#DCD8D0]">
        <div className="container-x py-4">
          <div className="flex items-center justify-between mb-3">
            <button
              onClick={onBack}
              disabled={step === 0}
              className="text-[#5C5C5C] disabled:opacity-30"
              data-testid="wizard-back-icon"
            >
              <ChevronLeft className="h-6 w-6" />
            </button>
            <div className="text-overline">{stepLabel}</div>
            <div className="text-sm text-[#8A8A8A] tabular-nums">
              {step + 1} / {totalSteps}
            </div>
          </div>
          <div className="h-2 w-full bg-[#EAE7E0] rounded-full overflow-hidden">
            <div
              className="h-full bg-marca transition-all duration-500 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </header>

      <main className="container-x py-6 fade-in">
        {title && (
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#1A1A1A] mb-2">
            {title}
          </h2>
        )}
        {children}
      </main>

      {!hideNav && (
        <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-[#DCD8D0] shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-40">
          <div className="container-x flex justify-between items-center gap-3">
            <Button
              variant="outline"
              onClick={onBack}
              disabled={step === 0 || loading}
              className="border-2 border-marca text-marca hover:bg-[#EAE7E0]"
              data-testid="wizard-back-btn"
            >
              <ChevronLeft className="h-4 w-4 mr-1" /> Atrás
            </Button>
            <Button
              onClick={onNext}
              disabled={nextDisabled || loading}
              aria-describedby={nextDescribedBy || undefined}
              className="bg-marca text-white hover:bg-marca-hover flex-1 sm:flex-none sm:px-8"
              data-testid="wizard-next-btn"
            >
              {loading ? (
                "Procesando..."
              ) : isLastStep ? (
                <>
                  Finalizar <Check className="h-4 w-4 ml-1" />
                </>
              ) : (
                <>
                  {nextLabel || "Siguiente"} <ChevronRight className="h-4 w-4 ml-1" />
                </>
              )}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
